<script lang="ts">
  import { portal } from '$lib/actions/portal';
  import { drawer } from '$lib/stores/drawer';
  import { beforeNavigate } from '$app/navigation';
  import Icon from '$components/ui/icon/icon.svelte';

  import { bodyLock } from '$lib/actions/body-lock';
  import { escapeKey } from '$lib/actions/escape-key';
  import { aboveLg } from '$lib/stores/breakpoints';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import { customSlide } from '$lib/transitions';
  import { navbarInfo } from '$components/navigation/navbar.svelte';
  import { fade, fly } from 'svelte/transition';
  import { cn } from '$lib/utils';
  import { bannerInfo } from './banner.svelte';

  beforeNavigate(({ from, to }) => {
    if (from?.url && to?.url && from.url.pathname !== to.url.pathname) drawer.close();
  });

  export let id: string;
  export let title: string | undefined = undefined;
  export let portalTarget: string | undefined = undefined;

  $: topnavBarHeight = `${($navbarInfo?.rect.top || 0) + ($navbarInfo?.rect.height || 0)}px`;
  const ariaTitle = title ? title.replace(/\s+/g, '-') : 'dialog-title';
</script>

{#if $drawer.id === id}
  <div
    use:portal={portalTarget || '#drawer'}
    role="dialog"
    aria-labelledby={ariaTitle}
    class="h-full w-full fixed inset-0 z-40 lg:z-50"
  >
    {#if $drawer.id && !$aboveLg && $navbarInfo?.rect}
      <aside
        use:bodyLock
        use:escapeKey={{ id: 'drawer', callback: () => drawer.close() }}
        transition:fly|global={{ duration: $reducedMotion ? 0 : 250, y: -100 }}
        class={cn(
          'fixed inset-0 z-40 w-full overflow-auto bg-background lg:hidden',
          $bannerInfo.isSticky ? 'top-24' : 'top-[--dynamic-navbar-height]'
        )}
        style="--dynamic-navbar-height: {topnavBarHeight}"
      >
        <slot />
      </aside>
    {/if}

    {#if $drawer.id && $aboveLg}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        role="button"
        tabindex="0"
        transition:fade|global={{ duration: 200 }}
        on:click={() => drawer.close()}
        class="fixed inset-0 z-50 bg-primary/40"
      />

      <aside
        use:bodyLock
        use:escapeKey={{ id: 'drawer', callback: () => drawer.close() }}
        transition:customSlide|global={{
          duration: $reducedMotion ? 0 : 250,
          axis: 'x',
          from: 20,
          to: 0
        }}
        class="fixed bottom-2 right-2 top-2 z-50 hidden w-full max-w-[480px] flex-col overflow-hidden rounded-sm bg-background pt-12 lg:flex"
      >
        <slot name="header">
          <div
            class="absolute top-0 z-50 flex h-12 w-full items-center justify-between border-b border-primary/2 px-4"
          >
            <h2 id={ariaTitle} class="text-md font-semibold">{title || ''}</h2>
            <button aria-label="close" class="flex h-fit" on:click={() => drawer.close()}>
              <Icon size="lg" icon="cross" />
            </button>
          </div>
        </slot>
        <div class="flex-1 overflow-auto">
          <slot />
        </div>
      </aside>
    {/if}
  </div>
{/if}
